module.exports = __webpack_public_path__ + "static/media/bowen-57.b28fa4a0.jpg";